import { ReactElement } from "react";
import classNames from "classnames";
import styles from "./Spinner.module.less";

type SpinnerSize = "normal" | "small";
type SpinnerColor = "primary" | "white";

export type SpinnerProps = {
	isInline?: boolean;
	size?: SpinnerSize;
	color?: SpinnerColor;
};

export const Spinner = (props: SpinnerProps): ReactElement => {
	const {
		isInline = false,
		size = "normal",
		color = "primary"
	} = props;

	return (
		<div
			className={classNames(
				styles.root,
				spinnerSizeToClass[size],
				colorToClassMap[color],
				{
					[styles.root_inline]: isInline
				}
			)}
		/>
	);
};
Spinner.displayName = "Spinner";

const spinnerSizeToClass: { [key in SpinnerSize]: string | undefined; } = {
	"small": styles.root_small,
	"normal": undefined
};

const colorToClassMap: Record<SpinnerColor, string | undefined> = {
	"primary": undefined,
	"white": styles.root_white
};
